import getCustomerAssets from '~/auth/assets'

import Link from './Link'

export default function EmailSupport() {
  const customerAssets = getCustomerAssets()
  const email = customerAssets?.supportEmail ?? 'support@synop.ai'

  return (
    <Link href={`mailto:${email}`} target="_blank">
      {email}
    </Link>
  )
}
